{
  "version": 1,
  "asset_id": "7ec7d221-9f63-40fe-9d7e-8401c62d0ae7",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7ec7d221-9f63-40fe-9d7e-8401c62d0ae7/bypass-weight-loss-graph-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7ec7d221-9f63-40fe-9d7e-8401c62d0ae7/bypass-weight-loss-graph-800.webp",
  "original_filename": "bypass-weight-loss-graph-800.webp",
  "size": 15930,
  "content_type": "image/webp",
  "created_at": "2026-10-04T16:12:48Z"
}
